import useAuthStore from "../../store/authStore";

const SessionExpiredModal = () => {
    const { sessionExpired, hideSessionExpired } = useAuthStore();

  if (!sessionExpired) return null;
    return(
        <>
        <div className="modal fade in" style={{ display: "block" }}>
        <div className="modal-dialog" style={{ width: "500px" }}>
          <div className="modal-content">

            {/* HEADER */}
            <div
              className="modal-header"
              style={{ padding: "0px 0px" }}
            >
              <button
                type="button"
                className="close"
                onClick={hideSessionExpired}
              >
                &times;
              </button>
              <h4
                className="modal-title"
                style={{ margin: 0 }}
              >
                Session Expired
              </h4>
            </div>

            {/* BODY */}
            <div className="modal-body">
              <p>
                Your session has expired. Please login again.
              </p>
            </div>

            {/* FOOTER */}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger"
                onClick={hideSessionExpired}
              >
                Login Again
              </button>

            </div>

          </div>
        </div>
      </div></>
    );
}

export default SessionExpiredModal;